import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="state-block">
    <span className="state-block__icon" aria-hidden="true">
      <strong style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem' }}>404</strong>
    </span>
    <h1 className="state-block__title">Page not found</h1>
    <p className="state-block__message">
      The page you are looking for may have been moved or no longer exists.
    </p>
    <div style={{ display: 'flex', gap: 'var(--space-3)', flexWrap: 'wrap', justifyContent: 'center' }}>
      <Link className="btn btn--primary" to="/">
        Back to home
      </Link>
      <Link className="btn btn--outline" to="/allproducts">
        Browse jewellery
      </Link>
    </div>
  </div>
);

export default NotFound;
